export default __webpack_public_path__ + "static/media/toggle.5643c90b.png";